import { PCON_LOGIN_PROFILE_URL } from '../constants/Api';
import { HelpLink, HelpIframeLink } from '../constants/LinkConstants';

// Submodules
import { Dict } from '../submodules/utils/Types';

import utils = egr.wcf.utils;

interface UrlBuilderArguments {
    queryArguments?: Dict;
    hashArguments?: Dict;
}

export abstract class UrlHelper {
    public static getPCONLoginUserProfileLink(language: string): string {
        return PCON_LOGIN_PROFILE_URL + language + '/';
    }

    public static getExternalHelpLink(language: string): string {
        let externalHelp: string = HelpLink.en;
        if (language && HelpLink[language]) {
            externalHelp = HelpLink[language];
        }
        return externalHelp;
    }

    public static getIFrameHelpLink(language: string): string {
        let helpLink: string = HelpIframeLink.en;
        if (language && HelpIframeLink[language]) {
            helpLink = HelpIframeLink[language];
        }
        return helpLink;
    }

    public static getImprintLink(language: string | null): string {
        if (utils.string.isNullOrEmpty(language)) {
            return 'https://www.easterngraphics.com/en/impressum.html';
        }
        return 'https://www.easterngraphics.com/' + language + '/impressum.html';
    }

    public static getLegalNoticeLink(language: string): string {
        return 'https://www.easterngraphics.com/' + language + '/legal-notice.html';
    }

    public static getEGRLink(language: string): string {
        return 'https://www.easterngraphics.com/' + language + '.html';
    }

    public static stripTrailingSlash(value: string): string {
        if (utils.string.isNullOrEmpty(value)) {
            return value;
        }
        return value.replace(/\/$/, '');
    }

    public static stripQueryString(url: string): string {
        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
        a.href = url;
        a.search = '';

        const value: string = a.href;
        if (value.endsWith('?')) { // Fix for IE/EDGE
            return value.substring(0, value.length - 1);
        }

        return value;
    }

    public static getQueryString(url: string): string {
        const a: HTMLAnchorElement = document.createElement('a') as HTMLAnchorElement;
        a.href = url;
        return a.search.slice(1);
    }

    public static parseQueryString(query: string): Dict {
        // http://stackoverflow.com/questions/901115/how-can-i-get-query-string-values-in-javascript
        let match: RegExpExecArray | null;
        const pl: RegExp = /\+/g;  // Regex for replacing addition symbol with a space
        const search: RegExp = /([^&=]+)=?([^&]*)/g;
        const decode: (s: string) => string = (s: string) => {
            return decodeURIComponent(s.replace(pl, ' '));
        };

        const urlParams: Dict = {};
        while (match = search.exec(query)) {
            urlParams[decode(match[1])] = decode(match[2]);
        }

        return urlParams;
    }

    public static buildQueryString(parameters: Dict): string {
        return Object.keys(parameters).map((key: string): string => {
            const value: string = parameters[key];
            if (utils.string.isNullOrEmpty(value)) {
                return key;
            }

            return key + '=' + encodeURIComponent(parameters[key]);
        }).join('&');
    }

    public static getCurrentLink(buildArguments?: UrlBuilderArguments): string {
        let url: string = document.location.origin + document.location.pathname;
        const queryString: string = UrlHelper.buildQueryString(
            jQuery.extend(
                {},
                UrlHelper.parseQueryString(document.location.search.substr(1)),
                buildArguments != null ? buildArguments.queryArguments : {}
            )
        );
        if (!utils.string.isNullOrEmpty(queryString)) {
            url += '?' + queryString;
        }

        const hashString: string = UrlHelper.buildQueryString(
            jQuery.extend(
                {},
                UrlHelper.parseQueryString(document.location.hash.substr(1)),
                buildArguments != null ? buildArguments.hashArguments : {}
            )
        );
        if (!utils.string.isNullOrEmpty(hashString)) {
            url += '#' + hashString;
        }

        return url;
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/UrlHelper.ts